import { render, staticRenderFns } from "./MultipleTicketDelivery.vue?vue&type=template&id=0748ec59&scoped=true&"
import script from "./MultipleTicketDelivery.vue?vue&type=script&lang=js&"
export * from "./MultipleTicketDelivery.vue?vue&type=script&lang=js&"
import style0 from "./MultipleTicketDelivery.vue?vue&type=style&index=0&id=0748ec59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0748ec59",
  null
  
)

export default component.exports